export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function trendLabel(trend?: string): string {
  switch (trend) {
    case 'rising':
      return '持续升温';
    case 'cooling':
      return '逐渐降温';
    case 'steady':
    default:
      return '热度平稳';
  }
}

export function trendClass(trend?: string): string {
  switch (trend) {
    case 'rising':
      return 'bg-primary-100 text-primary-700';
    case 'cooling':
      return 'bg-secondary-100 text-secondary-800';
    case 'steady':
    default:
      return 'bg-accent-100 text-accent-800';
  }
}